module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABP0lEQVRYR8WWsW7CMBCGz3Ol7DxBn6PiGZAYunSoz47EwsLaoVMzdKmSXsTQpQtMbGw8By8TV0gghTSOzcnhvNrn/9Nv+/cpEB5KWB/kAaqqeuO4YK1l1XW1FBE5DgAiJnFPHqCu6wPHAa3101BdWZaPeZ4fQ3snsbErQkQTANg757bGmPchiOQARVE8ZFm2A4DpWXiFiB8+iOQARDQDgE1HcImIn30QyQFOIh6IBSJ+/XuGoUvCne+DcM5ZY8x3e89RHLgIeJx4RcT1Zc2oAL7jaJrmxVr7c5pX3Chu2xiK5T4nlFLPWutfdhK2AWJi2XMn5vIA3ChuOxCK5cEj4D6z2Lo+8atLGLsRZ53oMxQNItEoFv+MxL/jc/zGNyRj5UB0S8btim+NYm9HJA5wj9/wrk3prYk5ekMSAhIH+ANdtKZf0VKMuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/public/components/query-table/table2/images/plus-gray.png
// module id = f4GK
// module chunks = 7